import { Paper, Stack, SxProps, Theme, useTheme } from '@mui/material';
import { ReactNode } from 'react';
export interface PaperResizerProps {
  children: ReactNode;
  color?: string;
  sx?: SxProps<Theme> | undefined;
}

/**
 * @summary Generic component containing a paper that is resizeable
 * Note that top level children are divided using MUI Divider components
 * @public
 */
export const PaperResizer = (props: PaperResizerProps) => {
  const { children, color, sx } = props;
  const theme = useTheme();

  return (
    <Stack
      direction="row"
      sx={{
        borderRight: `1px solid ${theme.palette.divider}`,
        minWidth: 0
      }}>
      <Paper
        elevation={0}
        square={true}
        sx={{
          ...sx,
          backgroundColor: color,
          display: 'flex',
          flexDirection: 'column',
          width: '100%'
        }}>
        {children}
      </Paper>
    </Stack>
  );
};
